import taskEditComponent from './task-edit.component';

const taskEditModule = angular.module('taskEdit', [
])
  .component('taskEdit', taskEditComponent)
  .name;

export default taskEditModule;
